import { render, staticRenderFns } from "./PartChildOrdersTable.vue?vue&type=template&id=13b5bb7b"
import script from "./PartChildOrdersTable.vue?vue&type=script&lang=js"
export * from "./PartChildOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./PartChildOrdersTable.vue?vue&type=style&index=0&id=13b5bb7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports